import Lookup from 'src/componentes/select2';

const Perfis = (props) => {
  return (
    <Lookup
      url="/PerfilLookup"
      labelKey="nome"
      valueKey="id"
      multi={true}
      {...props}
    />
  );
};

export default Perfis;
